import React from "react";
import "../../css/carousels.css";

function SlideFour({ size }) {
  return (
    <div style={size}>
      <svg
        id="Floor_4"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1000 795"
        style={{ width: "100%", maxWidth: "1000px" }}
      >
        <rect class="four_st12" y="0" width="1000" height="795" />
        <polygon
          class="four_st9"
          points="424.05 2.39 428.25 3.03 432.18 4.23 435.54 6.49 438.51 9.21 440.48 12.72 442.1 16.47 442.27 20.68 441.97 24.86 440.48 28.64 438.48 32.13 435.45 34.76 432.17 37.09 428.25 38.35 424.05 38.96 419.85 38.32 415.93 37.09 412.56 34.86 409.63 32.11 407.53 28.68 406.05 24.87 405.7 20.68 405.97 16.47 407.55 12.69 409.69 9.29 412.61 6.57 415.94 4.3 419.87 3.13 424.05 2.39 424.05 2.39"
        />
        <g>
          <polygon
            class="four_st12"
            points="547.78 235.65 576.78 236.53 605.17 235.37 633.55 236.16 661.94 235.2 690.33 236.75 718.71 235.14 745.98 236.85 747.27 263.67 746.14 291.27 748.04 318.86 745.64 346.46 747.73 374.05 746.6 401.65 747.66 429.64 718.71 428.7 690.33 429.67 661.94 429.03 633.55 429.78 605.17 429.16 576.78 429.82 548.7 429.04 546.8 401.65 548.72 374.05 548.33 346.46 549.46 318.86 548.08 291.27 550.05 263.67 547.78 235.65 547.78 235.65"
          />
          <polygon
            class="four_st6"
            points="547.78 235.72 576.78 236.59 605.17 235.43 633.55 236.23 661.94 235.27 690.33 236.82 718.71 235.21 745.98 236.92 747.27 263.74 746.14 291.34 748.04 318.93 745.64 346.53 747.73 374.12 746.6 401.72 747.66 429.71 718.71 428.77 690.33 429.74 661.94 429.1 633.55 429.85 605.17 429.23 576.78 429.88 548.7 429.1 546.8 401.72 548.72 374.12 548.33 346.53 549.46 318.93 548.08 291.34 550.05 263.74 547.78 235.72 547.78 235.72"
          />
        </g>
        <g>
          <polygon
            class="four_st12"
            points="370.29 163.72 346.09 165.25 322.14 163.2 294.7 163.72 256.36 162.72 201.76 162.1 200.86 17.17 371.13 17.65 369.7 53.35 371.92 97.65 370.29 138.83 370.29 163.72"
          />
          <polyline
            class="four_st6"
            points="202.18 163.25 201.17 142.96 202.06 122.06 200.56 101.16 202.45 80.25 200.8 59.35 201.7 38.45 200.86 17.24 225.6 17.98 249.89 17.21 274.19 17.72 298.48 17.12 322.78 17.61 347.08 17.1 371.13 17.71"
          />
        </g>
        <path
          class="four_st15"
          d="M594,595.89h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
        />
        <path
          class="four_st15"
          d="M594,595.89h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
        />
        <line class="four_st3" x1="995" y1="162.63" x2="995" y2="211.55" />
        <g id="Jharokhe">
          <polygon
            class="four_st12"
            points="796 598.32 817.74 598.98 839.02 598.11 860.3 598.7 881.58 597.98 902.87 599.14 924.15 597.94 944.6 599.22 945.55 619.19 944.71 639.73 946.13 660.28 944.34 680.83 945.9 701.38 945.06 721.92 945.85 742.76 924.15 742.06 902.87 742.79 881.58 742.31 860.3 742.87 839.02 742.41 817.74 742.9 796.68 742.31 795.26 721.92 796.7 701.38 796.41 680.83 797.25 660.28 796.22 639.73 797.69 619.19 796 598.32 796 598.32"
          />
          <g>
            <polygon
              class="four_st7"
              points="796 598.39 817.74 599.04 839.02 598.17 860.3 598.77 881.58 598.05 902.87 599.21 924.15 598 944.6 599.28 945.55 619.25 944.71 639.8 946.13 660.35 944.34 680.9 945.9 701.44 945.06 721.99 945.85 742.83 924.15 742.13 902.87 742.86 881.58 742.38 860.3 742.93 839.02 742.48 817.74 742.96 796.68 742.38 795.26 721.99 796.7 701.44 796.41 680.9 797.25 660.35 796.22 639.8 797.69 619.25 796 598.39 796 598.39"
            />
            <g>
              <path
                class="four_st15"
                d="M841.69,675.79c.28.13.9.32,1.69.32,1.75,0,2.45-1.01,2.45-2.31v-8.11h-1.15v8.08c0,.89-.35,1.28-1.23,1.28-.61,0-1.07-.15-1.39-.33l-.38,1.06h.01Z"
              />
              <path
                class="four_st15"
                d="M851.92,667.86c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
              />
              <path
                class="four_st15"
                d="M860.9,674.07c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM859.26,667.87c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
              />
              <path
                class="four_st15"
                d="M868.72,667.93c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.96-1.02.29,0,.6.03.89.12v-1.18h0Z"
              />
              <path
                class="four_st15"
                d="M870.77,671.88c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.56,3.08-2.09,3.08-2.16-1.05-2.16-3.18h.01ZM872.84,676.06c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
              />
              <path
                class="four_st15"
                d="M879.32,664.85h-1.14v11.07h1.14v-11.07h0ZM879.53,671.86l2.99,4.07h1.45l-3.11-4.1v-.06l2.93-3.78h-1.42l-2.85,3.81v.06h0Z"
              />
              <path
                class="four_st15"
                d="M888.97,667.86c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
              />
              <path
                class="four_st15"
                d="M898.91,674.44c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.88h0ZM896.71,668.83c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h-.01Z"
              />
            </g>
          </g>
        </g>
        <g id="Signage_list">
          <path
            class="four_st15"
            d="M9.69,36.21c0,1.12-.91,2.02-2.02,2.02s-2.02-.91-2.02-2.02.91-2.02,2.02-2.02,2.02.91,2.02,2.02h0Z"
          />
          <g>
            <path
              class="four_st15"
              d="M3.42,46.1c-.49,0-.89-.39-.9-.89l-.05-3.46c0-.26.11-.51.3-.68l2.37-2.13c.19-.17.44-.25.7-.23l2.09.22,1.63-.21c.36-.05.72.13.9.45l1.74,3.08,1.85-1.13c.42-.26.98-.13,1.24.3.26.42.13.98-.3,1.24l-2.65,1.62c-.21.13-.46.17-.7.1-.24-.06-.44-.22-.56-.43l-1.9-3.37-1.13.14h-.21l-1.8-.19-1.77,1.59.05,3.05c0,.5-.39.91-.89.91h0v.02Z"
            />
            <path
              class="four_st15"
              d="M5.09,57.31c-.05,0-.1,0-.16,0-.56-.09-.95-.61-.86-1.18l1.54-10.07c.05-.3.22-.57.48-.72.26-.16.58-.19.87-.1l6.1,2.04c.47.16.76.62.7,1.11l-.54,4.09c-.07.56-.59.96-1.16.89-.56-.07-.96-.59-.89-1.16l.43-3.25-4.13-1.38-1.35,8.86c-.08.51-.52.88-1.02.88h0Z"
            />
            <path
              class="four_st15"
              d="M9.78,47.78h-4.2c-.1,0-.18-.08-.18-.18v-8.69c0-.1.08-.18.18-.18h4.2c.1,0,.19.08.19.18v8.69c0,.1-.08.18-.19.18h0Z"
            />
            <polygon
              class="four_st15"
              points="23.06 49.85 15.72 49.85 16.71 53.41 9.05 53.41 10.04 56.98 1.97 56.98 1.97 59 13.19 59 12.2 55.43 19.86 55.43 18.87 51.86 23.63 51.86 23.06 49.85 23.06 49.85"
            />
            <path
              class="four_st15"
              d="M50.99,46.39c-1.47,0-2.45-.6-3.13-1.16l-.82,1.12c.7.63,1.98,1.3,3.83,1.3,2.63,0,4.1-1.54,4.1-3.4,0-3.78-5.85-3.19-5.85-6.02,0-1.12.86-1.93,2.29-1.93,1.03,0,1.79.35,2.4.84l.86-1.09c-.7-.58-1.79-1.03-3.17-1.03-2.21,0-3.8,1.44-3.8,3.29,0,3.87,5.85,3.24,5.85,6.02,0,1.14-.89,2.05-2.56,2.05h0Z"
            />
            <path
              class="four_st15"
              d="M60.01,47.56c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="four_st15"
              d="M68.87,45.25c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM66.89,37.81c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M73.95,47.47h1.37v-9.52h-1.37v9.52h0ZM73.56,35.18c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M83.31,37.88c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M89.21,44.95c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
          </g>
          <path
            class="four_st15"
            d="M13.49,9.07c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
          />
          <g>
            <path
              class="four_st15"
              d="M25.84,18.83c-.1-.1-.26-.1-.36,0l-.76.76v-2.88c0-.14-.11-.25-.26-.25s-.25.11-.25.25v2.88l-.76-.76c-.1-.1-.26-.1-.36,0s-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h.01Z"
            />
            <path
              class="four_st15"
              d="M25.84,12.94l-1.16-1.16s-.06-.05-.1-.06c-.03-.01-.07-.02-.11-.02s-.07,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.76-.75v2.87c0,.14.11.26.25.26s.26-.11.26-.26v-2.88l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h-.01Z"
            />
            <path
              class="four_st15"
              d="M3.6,4.59c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7V5.29c0-.38-.31-.7-.7-.7H3.6ZM19.8,28.47H3.6c-.9,0-1.63-.73-1.63-1.63V5.29c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
            />
            <path
              class="four_st15"
              d="M13.87,11.36h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.37c0-.63-.6-1.14-1.34-1.14h.02Z"
            />
            <polygon
              class="four_st15"
              points="47.22 4.83 47.22 17.1 53.89 17.1 53.89 15.86 48.62 15.86 48.62 4.83 47.22 4.83 47.22 4.83"
            />
            <path
              class="four_st15"
              d="M56.08,17.1h1.37V7.58h-1.37v9.52h0ZM55.7,4.81c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M65.5,3.87c-.37-.12-.81-.21-1.47-.21-1.86,0-2.71,1.01-2.71,2.49v1.44h-1.59v1.07h1.58v8.46h1.37v-8.46h2.49v-1.07h-2.47v-1.45c0-.86.35-1.28,1.26-1.28.54,0,.93.05,1.28.18l.28-1.16h-.02Z"
            />
            <path
              class="four_st15"
              d="M69.7,17.19c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h-.01Z"
            />
          </g>
          <g>
            <path
              class="four_st15"
              d="M12.8,77.6c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h.02Z"
            />
            <path
              class="four_st15"
              d="M14.71,72.08c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="four_st15"
              d="M13.42,81.58l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="four_st15"
              d="M19.91,77.83h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="four_st15"
              d="M17.3,74.37h0c-.17-.07-.26-.26-.19-.43s.26-.26.43-.19.26.26.19.43c-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.63c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04s.16.33.04.47c-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,74.98h0c-.12-.14-.09-.35.05-.47s.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.57c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h.01ZM18.59,75.87c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0v.02ZM15.1,76.55c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h.01ZM19.1,76.84h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="four_st15"
              d="M12.8,77.6c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h.02Z"
            />
            <path
              class="four_st15"
              d="M14.71,72.08c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="four_st15"
              d="M13.42,81.58l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="four_st15"
              d="M19.91,77.83h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="four_st15"
              d="M17.3,74.37h0c-.17-.07-.26-.26-.19-.43s.26-.26.43-.19.26.26.19.43c-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.63c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04s.16.33.04.47c-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,74.98h0c-.12-.14-.09-.35.05-.47s.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.57c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h.01ZM18.59,75.87c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0v.02ZM15.1,76.55c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h.01ZM19.1,76.84h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="four_st15"
              d="M47.22,77.95h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM48.62,66.92h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="four_st15"
              d="M63.08,68.35c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M65.1,77.95h1.37v-9.52h-1.37v9.52h0ZM64.71,65.66c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M76.9,71.38c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M81.12,64.66h-1.37v13.29h1.37v-13.29h0ZM81.38,73.06l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
            />
            <path
              class="four_st15"
              d="M88.98,77.95h1.37v-9.52h-1.37v9.52h0ZM88.59,65.66c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M100.78,71.38c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M110.48,68.83c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM109.13,69.79v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="four_st15"
              d="M52.26,90.84l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07,0Z"
            />
            <path
              class="four_st15"
              d="M65.18,96.74c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.21,89.29c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h-.01Z"
            />
            <path
              class="four_st15"
              d="M72.54,99.05c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h-.01Z"
            />
            <path
              class="four_st15"
              d="M82.54,97.17c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM79.89,90.45c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M90.75,89.36c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
          </g>
          <g>
            <path
              class="four_st11"
              d="M18.66,356.02v2.97c0,.28.38.42.69.38.4-.05.41-.27.41-.66v-1.07c0-.57.06-1.8-.13-2.21-.11-.22-.36-.51-.55-.62-.4-.23-1.56-.24-2.11-.24-.87,0-1.57.06-2.1.54-.23.21-.31.48-.35.9-.04.41-.05,2.39-.03,3,.02.42.55.42.78.33.17-.07.21-.15.21-.37v-2.8h.22c.02,2.51.04,5.01.05,7.51,0,.28-.05.65.11.84.26.3.82.18,1.04-.05.09-.1.09-.21.09-.38l.04-3.73c0-.78-.06-.72.2-.69v4.32c.02.25-.02.52.14.65.15.12.42.13.63.06.51-.16.49-.6.48-1.05-.02-2.16-.02-3.81,0-5.91,0-.29,0-.57.01-.85,0-.1,0-.71.02-.81v-.04h.15v-.02Z"
            />
            <path
              class="four_st11"
              d="M9.91,356.05c.25-.05.21.03.21.23.02,2.66.02,4.65,0,7.31,0,.54,0,.85.38,1.05.22.11.86.22.86-.36v-4.62h.21c0,1.23.02,2.46.03,3.69,0,.27-.02.67.01.93.02.21.3.36.54.4.31.05.55-.06.65-.27.09-.18.05-.65.05-.88.02-2.46.04-4.92.05-7.37h.21v2.82c0,.46.54.43.74.36.15-.06.25-.13.25-.33.02-.63.01-2.51-.02-2.96-.03-.43-.11-.71-.34-.93-.46-.44-1.15-.55-1.99-.55-.58,0-1.82,0-2.24.25-.18.11-.45.42-.55.65-.13.29-.12.73-.12,1.07v1.66c0,.69-.11,1.13.4,1.2.17.03.32,0,.45-.08.18-.1.18-.21.18-.42,0-.63-.03-2.32.02-2.83v-.02h.02Z"
            />
            <path
              class="four_st11"
              d="M23.5,365.07c.52,0,2.84.06,3.13-.13-.04-.21-1.1-1.23-1.34-1.47-.16-.15-.3-.31-.47-.47l-4.58.1c-.04.67-.03,1.4-.04,2.07-.01.69-.03,1.38-.04,2.07,0,.1-.02.44,0,.5.02.07,1.19,1.17,1.33,1.3.09.09.45.43.59.45.21-.3.1-2.43.14-2.96.08.05.33.31.41.4l1.99,1.98c.15.14.67.7.82.76l.7-.61c.11-.12.57-.56.68-.63-.04-.1-.33-.36-.42-.45l-2.89-2.92h-.01Z"
            />
            <path
              class="four_st11"
              d="M8.53,363.03c-.18-.03-3.93,0-4.22,0h-.28c-.12,0-.3.23-.43.36-.31.3-1.38,1.31-1.55,1.61.27.12,2.59.15,3.08.17-.03.07,0,.02-.05.08l-2.73,2.69c-.12.12-.28.26-.38.38.11.12.22.23.33.35.11.11.21.24.33.34l.66.69c.12-.07,3.24-3.25,3.36-3.3,0,.83-.08,2.41.12,3.13.21-.04,1.07-.94,1.23-1.11.05-.05.08-.09.13-.14.33-.35.41-.34.4-.62-.01-1.53.02-3.07,0-4.61h0v-.02Z"
            />
            <path
              class="four_st11"
              d="M22.28,348.03c-.01-.52-.05-2.55-.18-2.92-.32-.02-1.38,1.14-1.67,1.43-.36.37-.29.21-.29.74v4.13c.21.03,4.17.01,4.73,0,.12,0,.34-.27.47-.4.22-.21,1.21-1.19,1.28-1.39-.28-.17-2.61-.04-3.13-.1l3.3-3.34c-.16-.19-.79-.74-1-.98-.07-.08-.26-.28-.35-.33-.16.09-3.08,3.13-3.19,3.15h.03Z"
            />
            <path
              class="four_st11"
              d="M6.57,348.02c-.09-.01-.34-.31-.41-.37l-1.18-1.18c-.26-.26-1.44-1.45-1.64-1.54-.24.1-1.18,1.05-1.29,1.3.17.37,2.96,2.95,3.06,3.22-.27.16-2.62.08-3.12.09l1.81,1.86c.09.05.39.02.51.02.27,0,4.07.02,4.22-.01v-4.21c0-.52.1-.41-.28-.77l-1.59-1.55-.1,3.15h0Z"
            />
            <path
              class="four_st11"
              d="M16.91,352.12c-.37.05-.53.16-.67.39-.35.56-.21,1.96,1.19,1.66.32-.07.51-.21.64-.42.28-.45.28-.73-.03-1.19-.1-.15-.14-.17-.28-.26-.23-.15-.53-.22-.85-.18h0Z"
            />
            <path
              class="four_st11"
              d="M11.4,352.12c-1.35.18-1.31,2.25.31,2.06.66-.08,1.04-.58.91-1.18-.11-.51-.59-.97-1.22-.88h0Z"
            />
            <path
              class="four_st11"
              d="M14.36,350.27c.63,0,1.15.51,1.15,1.15s-.51,1.15-1.15,1.15-1.15-.51-1.15-1.15.51-1.15,1.15-1.15h0Z"
            />
            <polygon
              class="four_st15"
              points="54.58 351.08 54.58 349.83 49.22 349.83 49.22 345.48 53.72 345.48 53.72 344.23 49.22 344.23 49.22 340.05 54.33 340.05 54.33 338.8 47.82 338.8 47.82 351.08 54.58 351.08 54.58 351.08"
            />
            <path
              class="four_st15"
              d="M63.31,342.87h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="four_st15"
              d="M77.95,349.29c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM75.31,342.57c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M86.16,341.48c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M94.56,341.96c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM93.22,342.92v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="four_st15"
              d="M103.53,349.29c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.88,342.57c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M114.17,344.51c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M116.52,346.46c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0v.02Z"
            />
            <path
              class="four_st15"
              d="M124.17,354.56c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="four_st15"
              d="M52.55,369.86c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM50.57,362.42c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M61.65,369.57c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M69.95,369.57c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M79.82,370.3c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h.01ZM77.18,363.58c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M89.73,363.88h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h-.01Z"
            />
            <path
              class="four_st15"
              d="M98.31,371.75c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0v-.02ZM101.2,371.07c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h-.01Z"
            />
            <path
              class="four_st15"
              d="M108.17,358.8v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35,0Z"
            />
            <path
              class="four_st15"
              d="M112.12,375.57c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="four_st15"
              d="M134.25,366.93c0-3.09-1.37-4.54-3.54-4.54-1.21,0-2.01.53-2.47,1.14h-.07l-.3-.96h-1.02v12.92h1.35v-3.55c.47.11,1.01.16,1.51.16,2.73,0,4.53-1.84,4.53-5.16h.01ZM128.21,370.67v-5.78c.33-.61,1.01-1.33,2.19-1.33,1.26,0,2.47.85,2.47,3.53,0,2.53-1.07,3.79-3.22,3.79-.38,0-1.03-.07-1.44-.21h0Z"
            />
            <path
              class="four_st15"
              d="M137.54,367.24c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM140.03,372.24c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="four_st15"
              d="M146.89,372.09h1.37v-9.52h-1.37v9.52h0ZM146.51,359.8c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M158.69,365.52c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M164.28,372.17c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
          </g>
          <g>
            <path
              class="four_st15"
              d="M7.52,240.95c-.77,0-1.4-.62-1.4-1.4v-9.3c0-.77.62-1.4,1.4-1.4s1.4.62,1.4,1.4v9.3c0,.77-.62,1.4-1.4,1.4h0Z"
            />
            <path
              class="four_st15"
              d="M14.19,235.86h-6.62c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h6.62c.53,0,.96.43.96.96s-.43.96-.96.96h0Z"
            />
            <path
              class="four_st15"
              d="M18.82,247.1c-.34,0-.68-.16-.89-.46l-4.08-5.69h-6.25c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1h6.81c.35,0,.69.17.89.46l3.77,5.26,2.2-1.54c.5-.35,1.18-.23,1.53.27s.23,1.18-.27,1.53l-3.09,2.17c-.19.13-.41.2-.63.2h0Z"
            />
            <path
              class="four_st15"
              d="M9.68,226.11c0,1.19-.96,2.15-2.15,2.15s-2.15-.96-2.15-2.15.96-2.15,2.15-2.15,2.15.96,2.15,2.15h0Z"
            />
            <path
              class="four_st15"
              d="M15.6,244.26c-1.17,1.92-3.28,3.2-5.68,3.2-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95,2.68,0,5.05-1.33,6.49-3.37l-.81-1.14h0Z"
            />
            <path
              class="four_st15"
              d="M48.4,232.41h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM49.8,221.38h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="four_st15"
              d="M59.96,232.41h1.37v-9.52h-1.37v9.52h0ZM59.57,220.12c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M69.05,229.89c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M77.78,230.18c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM75.8,222.74c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M82.4,232.07c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0v-.02ZM85.29,231.39c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h-.01Z"
            />
            <path
              class="four_st15"
              d="M92.26,219.12v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35,0Z"
            />
            <path
              class="four_st15"
              d="M103.25,230.62c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h.01ZM100.61,223.9c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M112.24,223.04c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0v.02ZM110.01,231.43c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="four_st15"
              d="M53.45,245.29l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07,0Z"
            />
            <path
              class="four_st15"
              d="M66.33,251.19c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM64.35,243.75c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M75.44,250.9c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M83.44,243.73c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h-.01Z"
            />
            <path
              class="four_st15"
              d="M94.06,243.82c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M96.51,248.57c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM99,253.57c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M106.3,248.57c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM108.79,253.57c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M121.65,245.21h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h-.01Z"
            />
          </g>
          <g>
            <polygon
              class="four_st17"
              points="8.35 408.86 14.35 408.86 14.35 402.48 20.73 402.48 20.73 396.48 14.35 396.48 14.35 390.1 8.35 390.1 8.35 396.48 1.97 396.48 1.97 402.48 8.35 402.48 8.35 408.86 8.35 408.86"
            />
            <polygon
              class="four_st15"
              points="48.64 406.03 48.64 400.76 53.09 400.76 53.09 399.52 48.64 399.52 48.64 395 53.7 395 53.7 393.76 47.22 393.76 47.22 406.03 48.64 406.03 48.64 406.03"
            />
            <path
              class="four_st15"
              d="M56.12,406.03h1.37v-9.52h-1.37v9.52h0ZM55.73,393.74c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M71.52,403.51c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M78.07,406.12c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h-.01Z"
            />
            <path
              class="four_st15"
              d="M91.97,403.81c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM89.99,396.37c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M97.05,406.03h1.37v-9.52h-1.37v9.52h0ZM96.66,393.74c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M107.18,396.66c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0v.02ZM104.96,405.05c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.1,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="four_st15"
              d="M65.48,396.43c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h-.01Z"
            />
          </g>
          <g>
            <polygon
              class="four_st15"
              points="53.98 317.99 53.98 316.75 48.62 316.75 48.62 312.39 53.12 312.39 53.12 311.15 48.62 311.15 48.62 306.96 53.73 306.96 53.73 305.72 47.22 305.72 47.22 317.99 53.98 317.99 53.98 317.99"
            />
            <path
              class="four_st15"
              d="M62.72,309.78h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h-.01Z"
            />
            <path
              class="four_st15"
              d="M77.35,316.21c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM74.71,309.48c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M85.56,308.4c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M93.97,308.87c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.23,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM92.62,309.83v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="four_st15"
              d="M102.93,316.21c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.29,309.48c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M113.57,311.43c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M115.92,313.37c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0v.02Z"
            />
            <path
              class="four_st15"
              d="M123.57,321.48c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="four_st15"
              d="M144.37,316.21c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM141.73,309.48c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="four_st15"
              points="152.86 317.99 154.44 317.99 151.37 313.07 154.26 308.47 152.67 308.47 150.64 312.01 150.57 312.01 148.43 308.47 146.86 308.47 149.76 313.04 146.68 317.99 148.28 317.99 150.5 314.12 150.57 314.12 152.86 317.99 152.86 317.99"
            />
            <path
              class="four_st15"
              d="M156.68,317.99h1.37v-9.52h-1.37v9.52h0ZM156.29,305.7c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M164.01,318.08c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="four_st11"
              d="M8.2,302.25c-1.1-.29-1.93.6-2.12,1.42-.27,1.15.46,2.06,1.28,2.29,2.33.64,3.18-3.08.84-3.7h0ZM6.49,311.21l.46-.56c.23-.25.44-.72.74-.87.18.19.15.23.28.48l.71,1.35c.11.4.61,1.09.69,1.43.06.25-.44,1.24-.55,1.52l-3.18,7.53c-.16.38-.55,1.18-.6,1.5,1.98.12,2.19.08,2.76-1.12.4-.83.82-1.76,1.22-2.6.3-.63,2.31-4.98,2.49-5.16.24.73.37,2,.55,2.85.09.47.15.91.29,1.37.15.51.32.72.89.78h6.73c-.06-.33-.48-1.15-.63-1.49-.27-.61-.35-.83-1.17-.86-1.24-.04-2.87.11-4.04-.03-.19-1.18-.46-4.09-.82-4.98-.28-.7-.58-1.36-.87-2.02-.74-1.74-1.13-2.16-.25-2.18h1.74c.17.35,1.64,2.95,1.99,3.07.48.17.95-.22,1.06-.56.14-.45-.23-.91-.41-1.26-.45-.84-1.37-2.82-1.93-3.06-.42-.18-2.65-.09-3.3-.09-2.46,0-3.47-.38-4.91,1.81-.27.41-1.03,1.82-1.3,1.99-.15-.01-.14-.06-.11.05-.54.03-1.48.08-2.04,0v-9.2c1.37.1,3.17,0,4.61-.01l4.49-.02s.04,0,.05-.02c0-.02.03-.01.04-.02l5.6.02v15.98c1.67.21,1.47-.33,2.21,1.2.22.45,1,1.9,1.06,2.28h-3.21c-.07.5-.11,3.18.06,3.44.12.19.67.72.86.93.14.16.73.75.79.91-2.92.12-6.48,0-9.55,0-.85,0-.59.11-1.26-.64-.45-.5-.64-.85-1.07-.87-.6-.03-1.29,0-1.9,0,.07.23,0,.11.15.31l.48.5c.17.19.51.52.61.67-.5.06-1.65.05-2.18.02-.37-.02-.43-.23-.63-.46-.17-.19-.33-.34-.51-.53-.79-.82-.72-.66-.72-1.46.02-3.58-.07-7.25,0-10.8.73-.05,1.71.07,2.39-.02.63-.09.77-.77,1.16-1.13h0l-.02.03Z"
            />
          </g>
          <path
            class="four_st11"
            d="M25.73,291.41v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h-.01Z"
          />
          <g>
            <polygon
              class="four_st15"
              points="48.64 283.89 48.64 278.62 53.09 278.62 53.09 277.38 48.64 277.38 48.64 272.86 53.7 272.86 53.7 271.62 47.22 271.62 47.22 283.89 48.64 283.89 48.64 283.89"
            />
            <path
              class="four_st15"
              d="M56.12,283.89h1.37v-9.52h-1.37v9.52h0ZM55.73,271.6c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M65.48,274.3c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h-.01Z"
            />
            <path
              class="four_st15"
              d="M73.1,282.11c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h.01ZM70.45,275.38c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M87.65,282.11c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM85,275.38c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="four_st15"
              points="96.14 283.89 97.71 283.89 94.65 278.97 97.54 274.37 95.94 274.37 93.91 277.91 93.84 277.91 91.71 274.37 90.13 274.37 93.04 278.94 89.96 283.89 91.55 283.89 93.77 280.02 93.84 280.02 96.14 283.89 96.14 283.89"
            />
            <path
              class="four_st15"
              d="M102.23,283.98c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h-.01Z"
            />
            <path
              class="four_st15"
              d="M106.62,283.89h1.37v-9.52h-1.37v9.52h0ZM106.24,271.6c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M118.42,277.33c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M128.12,274.77c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM126.78,275.73v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="four_st15"
              d="M130.98,280.88c.05,2.17,1.14,3.2,3.1,3.2,1.59,0,2.45-.82,2.71-1.19h.07l.26,1h1.07v-9.52h-1.37v6.25c-.03,1.51-1.03,2.29-2.4,2.29s-2.08-.75-2.08-2.31v-6.23h-1.37v6.51h0Z"
            />
            <path
              class="four_st15"
              d="M141.55,283.89h1.37v-9.52h-1.37v9.52h0ZM141.17,271.6c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M150.64,281.37c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M158.64,274.21c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="four_st15"
              d="M170.56,282.11c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM167.92,275.38c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M178.77,274.3c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h-.01Z"
            />
            <path
              class="four_st11"
              d="M4.57,276s.02-.03.1-.04h5.98c.4,0,.29.01.32.09v3.76h-6.38c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0v-.02ZM3.56,273.68c0,2.93,0,5.88,0,8.82s-.07,5.95,0,8.87h8.32v-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07h-2.5s0,.92,0,.92c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.88.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h-.02Z"
            />
            <path
              class="four_st11"
              d="M25.73,284.88v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h.01Z"
            />
            <path
              class="four_st11"
              d="M17.32,272.03c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
            />
            <path
              class="four_st11"
              d="M16.45,283.46c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
            />
            <path
              class="four_st11"
              d="M25.73,278.02v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h-.01Z"
            />
          </g>
          <g>
            <path
              class="four_st0"
              d="M17.93,422.78H4c-1.12,0-2.03.91-2.03,2.03v13.93c0,1.12.91,2.03,2.03,2.03h13.93c1.12,0,2.03-.91,2.03-2.03v-13.93c0-1.12-.91-2.03-2.03-2.03h0Z"
            />
            <path
              class="four_st15"
              d="M10.47,433.37h-.91v3.91h-2.4v-11h3.77c2.23,0,3.84.83,3.84,3.26,0,2.06-1.08,3.83-4.3,3.83h0ZM10.54,428.3h-.97v3.11h.79c1.6,0,1.95-.69,1.95-1.54,0-1.08-.53-1.57-1.76-1.57h0Z"
            />
            <g>
              <path
                class="four_st15"
                d="M50.76,424.24h-3.54v12.27h1.4v-4.85h1.87c2.82,0,4.24-1.45,4.24-3.9s-1.54-3.52-3.97-3.52h0ZM50.44,425.48c1.86,0,2.84.68,2.84,2.43,0,1.63-.75,2.52-2.78,2.52h-1.87v-4.95h1.82-.01Z"
              />
              <path
                class="four_st15"
                d="M60.91,434.29c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.94,426.85c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.46.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
              />
              <path
                class="four_st15"
                d="M70.3,426.92c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
              />
              <path
                class="four_st15"
                d="M73.22,423.22h-1.37v13.29h1.37v-13.29h0ZM73.48,431.63l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
              />
              <path
                class="four_st15"
                d="M81.08,436.51h1.37v-9.52h-1.37v9.52h0ZM80.7,424.22c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
              />
              <path
                class="four_st15"
                d="M92.88,429.95c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
              />
              <path
                class="four_st15"
                d="M102.58,427.39c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.1,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM101.23,428.35v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.1,1.56.26h0Z"
              />
            </g>
          </g>
          <g>
            <path
              class="four_st15"
              d="M10.19,123.24c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
            />
            <path
              class="four_st15"
              d="M13.9,134.13l-1.54-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9.49.08.97-.19,1.07-.61l1.56-6.74v-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.43.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.05,0-.11-.03-.16l-1.9-9.83h.32v.04l1.56,6.74c.09.37.47.62.89.62.06,0,.12,0,.18,0,.49-.08.81-.48.72-.9h-.03Z"
            />
            <polygon
              class="four_st15"
              points="47.22 117.16 47.22 129.44 53.89 129.44 53.89 128.19 48.62 128.19 48.62 117.16 47.22 117.16 47.22 117.16"
            />
            <path
              class="four_st15"
              d="M60.55,127.21c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.57,119.77c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M70.7,120.07c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0v.02ZM68.48,128.45c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="four_st15"
              d="M75.41,129.44h1.37v-9.52h-1.37v9.52h0ZM75.02,117.15c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="four_st15"
              d="M86.07,127.65c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM83.43,120.93c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M94,126.91c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.87-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M52.26,142.32l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07,0Z"
            />
            <path
              class="four_st15"
              d="M65.15,148.22c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.17,140.78c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M74.25,147.92c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M82.25,140.76c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h-.01Z"
            />
            <path
              class="four_st15"
              d="M92.88,140.85c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M95.33,145.6c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM97.82,150.6c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M105.12,145.6c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.67,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM107.6,150.6c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M120.47,142.23h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h-.01Z"
            />
          </g>
          <g>
            <path
              class="four_st15"
              d="M8.55,174.69c0,1.23-.99,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
            />
            <path
              class="four_st15"
              d="M9.02,177.53H3.64c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.48c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h-.02Z"
            />
            <path
              class="four_st15"
              d="M51.9,168.47c-2.92,0-5.27,1.93-5.27,6.36,0,4.18,1.68,6.27,4.85,6.27,1.89,0,3.06-.46,3.85-1.1v-5.3h-1.4v4.69c-.49.33-1.37.49-2.15.49-2.4,0-3.71-1.47-3.71-5.16,0-4.01,1.96-4.96,3.75-4.96,1.22,0,2.03.33,2.56.84l.91-1.07c-.4-.38-1.35-1.05-3.38-1.05h0Z"
            />
            <path
              class="four_st15"
              d="M64.21,179.14c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h.01ZM61.56,172.41c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="four_st15"
              d="M74.85,174.36c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h-.02Z"
            />
            <path
              class="four_st15"
              d="M80.44,181.01c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h-.01Z"
            />
            <path
              class="four_st15"
              d="M88.86,178.4c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M52.25,193.81l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.44,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="four_st15"
              d="M65.14,199.71c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.16,192.27c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0v.02Z"
            />
            <path
              class="four_st15"
              d="M74.24,199.41c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="four_st15"
              d="M82.24,192.25c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h-.01Z"
            />
            <path
              class="four_st15"
              d="M92.87,192.34c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="four_st15"
              d="M95.32,197.08c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM97.8,202.09c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M105.1,197.08c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h-.01ZM107.59,202.09c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h-.01Z"
            />
            <path
              class="four_st15"
              d="M120.46,193.72h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h-.01Z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                class="four_st15"
                d="M557.47,576.92c0-.49.39-.89.89-.9l3.46-.05c.26,0,.51.1.68.3l2.13,2.38c.17.19.25.44.23.7l-.22,2.09.21,1.63c.05.36-.13.72-.45.9l-3.08,1.74,1.13,1.85c.26.42.13.98-.3,1.24s-.98.13-1.24-.3l-1.62-2.65c-.13-.21-.17-.46-.1-.7.06-.24.22-.44.43-.56l3.37-1.9-.14-1.13v-.21l.19-1.8-1.59-1.77-3.05.05c-.5,0-.91-.39-.91-.89h0l-.02-.02Z"
              />
              <path
                class="four_st15"
                d="M567.36,583.19c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02h0Z"
              />
              <path
                class="four_st15"
                d="M546.25,578.58s0-.1.01-.16c.09-.56.61-.95,1.18-.86l10.07,1.54c.3.05.57.22.73.48s.19.58.1.87l-2.04,6.1c-.16.47-.62.76-1.11.69l-4.09-.54c-.57-.07-.96-.59-.89-1.16.08-.57.59-.96,1.16-.89l3.25.43,1.38-4.13-8.86-1.35c-.51-.08-.88-.52-.88-1.02h0Z"
              />
              <path
                class="four_st15"
                d="M555.79,583.28v-4.2c0-.1.08-.19.19-.19h8.69c.1,0,.19.08.19.19v4.2c0,.1-.08.18-.19.18h-8.69c-.1,0-.19-.08-.19-.18h0Z"
              />
              <polygon
                class="four_st15"
                points="553.72 596.56 553.72 589.21 550.15 590.21 550.15 582.54 546.59 583.54 546.59 575.47 544.57 575.47 544.57 586.69 548.14 585.7 548.14 593.36 551.7 592.37 551.7 597.13 553.72 596.56 553.72 596.56"
              />
            </g>
            <g>
              <path
                class="four_st15"
                d="M546.95,606.16c0-.74.3-1.23.58-1.57l-.56-.41c-.32.35-.65.99-.65,1.92,0,1.31.77,2.05,1.7,2.05,1.89,0,1.59-2.92,3.01-2.92.56,0,.96.43.96,1.15,0,.52-.18.89-.42,1.2l.54.43c.29-.35.52-.89.52-1.58,0-1.1-.72-1.9-1.65-1.9-1.93,0-1.62,2.92-3.01,2.92-.57,0-1.02-.45-1.02-1.28h0Z"
              />
              <path
                class="four_st15"
                d="M546.37,610.66c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
              />
              <path
                class="four_st15"
                d="M547.52,615.09c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86c.72,0,1,.9.95,2.05h-1.07.01ZM551.24,614.1c0-.99-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62h.01Z"
              />
              <path
                class="four_st15"
                d="M546.41,617.63v.68h4.76v-.68h-4.76ZM552.55,617.44c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M551.21,622.31c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
              <path
                class="four_st15"
                d="M547.67,625.26c-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63-1.61,0-1.18,2.41-2.26,2.41h-.01Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="four_st15"
                d="M586.89,595.66c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h.02Z"
              />
              <path
                class="four_st15"
                d="M588.8,590.14c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
              />
              <path
                class="four_st15"
                d="M587.51,599.64l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
              />
              <path
                class="four_st15"
                d="M591.39,592.43h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19s.26.26.19.43c-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.69c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,593.04h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.64c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,593.93c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12s.04.36-.12.45c-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0v.02ZM589.19,594.61c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,594.9h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
              />
              <path
                class="four_st15"
                d="M586.89,595.66c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h.02Z"
              />
              <path
                class="four_st15"
                d="M588.8,590.14c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
              />
              <path
                class="four_st15"
                d="M587.51,599.64l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
              />
              <path
                class="four_st15"
                d="M591.39,592.43h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19s.26.26.19.43c-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.69c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,593.04h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.64c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,593.93c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12s.04.36-.12.45c-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0v.02ZM589.19,594.61c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,594.9h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
              />
            </g>
            <g>
              <path
                class="four_st15"
                d="M584.42,620.24v1.6c0,1.88,1.13,2.69,3.12,2.69s3.01-.83,3.01-2.68v-1.61h-6.14.01ZM589.93,620.94v.85c0,1.3-.64,2.02-2.47,2.02s-2.43-.63-2.43-1.98v-.89h4.9Z"
              />
              <path
                class="four_st15"
                d="M589.22,628.17c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
              <path
                class="four_st15"
                d="M584.42,629.18v.68h4.76v-.68h-4.76ZM590.56,628.98c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M587.7,635.07c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28-.01Z"
              />
              <path
                class="four_st15"
                d="M591.06,637.18v-.68h-6.64v.68h6.64ZM586.86,637.32l-2.44,1.79v.87l2.46-1.86h.03l2.27,1.76v-.85l-2.28-1.71h-.04Z"
              />
              <path
                class="four_st15"
                d="M584.42,641.11v.68h4.76v-.68h-4.76ZM590.56,640.92c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M587.7,647.01c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28-.01Z"
              />
              <path
                class="four_st15"
                d="M588.98,651.86c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM588.5,651.19h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
              />
              <path
                class="four_st15"
                d="M577.98,622.76l-4.06.97v.92l4.76,1.28v-.66l-2.62-.67c-.5-.13-1.02-.25-1.54-.37v-.04c.48-.1.91-.2,1.35-.31l2.81-.7v-.88l-2.81-.72c-.44-.11-.88-.21-1.35-.31v-.04c.53-.11,1.02-.23,1.53-.36l2.63-.67v-.7l-4.76,1.26v.92l4.06,1.01v.04h0v.03Z"
              />
              <path
                class="four_st15"
                d="M575.03,629.22c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86c.72,0,1,.9.95,2.05h-1.07.01ZM578.75,628.23c0-.99-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62h.01Z"
              />
              <path
                class="four_st15"
                d="M573.87,632.9c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
              />
              <path
                class="four_st15"
                d="M574.81,637.89c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,636.57c0,.77-.45,1.12-1.27,1.12h-.27v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="four_st15"
                d="M578.71,642c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71-.01Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="four_st11"
                d="M574.33,670.4s.02-.03.1-.04h5.98c.4,0,.29.01.32.09v3.76h-6.38c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0v-.02ZM573.32,668.08c0,2.93-.01,5.88-.01,8.82s-.07,5.95,0,8.87h8.32v-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07h-2.5s0,.92,0,.92c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.87.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h-.02Z"
              />
              <g>
                <path
                  class="four_st11"
                  d="M595.49,679.28v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h.01Z"
                />
                <path
                  class="four_st11"
                  d="M587.08,666.43c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
                />
                <path
                  class="four_st11"
                  d="M586.21,677.87c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
                />
                <path
                  class="four_st11"
                  d="M595.49,685.81v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h0Z"
                />
                <path
                  class="four_st11"
                  d="M595.49,672.42v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h0Z"
                />
              </g>
            </g>
            <g>
              <polygon
                class="four_st15"
                points="584.42 690.05 587.05 690.05 587.05 692.27 587.68 692.27 587.68 690.05 589.93 690.05 589.93 692.58 590.56 692.58 590.56 689.34 584.42 689.34 584.42 690.05 584.42 690.05"
              />
              <path
                class="four_st15"
                d="M584.42,693.79v.68h4.76v-.68h-4.76ZM590.56,693.6c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M589.22,698.47c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
              <path
                class="four_st15"
                d="M585.31,702.28c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM588.67,700.96c0,.77-.45,1.12-1.27,1.12h-.27v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="four_st15"
                d="M574.81,692.27c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,690.95c0,.77-.45,1.12-1.27,1.12h-.27v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <polygon
                class="four_st15"
                points="573.92 696.52 573.92 697.31 576.38 695.78 578.68 697.22 578.68 696.42 576.91 695.41 576.91 695.37 578.68 694.3 578.68 693.52 576.39 694.97 573.92 693.43 573.92 694.23 575.85 695.34 575.85 695.37 573.92 696.52 573.92 696.52"
              />
              <path
                class="four_st15"
                d="M573.87,699.57c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
              />
              <path
                class="four_st15"
                d="M573.92,701.76v.68h4.76v-.68h-4.76ZM580.06,701.57c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M577.2,707.66c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28-.01Z"
              />
              <path
                class="four_st15"
                d="M578.48,712.51c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM578,711.84h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
              />
              <path
                class="four_st15"
                d="M575.42,713.94c-1.09.03-1.6.57-1.6,1.55,0,.8.41,1.22.59,1.36v.04l-.5.13v.53h4.76v-.68h-3.12c-.75-.02-1.15-.52-1.15-1.2s.38-1.04,1.16-1.04h3.12v-.68h-3.26Z"
              />
              <path
                class="four_st15"
                d="M573.92,719.23v.68h4.76v-.68h-4.76ZM580.06,719.03c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="four_st15"
                d="M575.18,723.77c-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63-1.61,0-1.18,2.41-2.26,2.41h-.01Z"
              />
              <path
                class="four_st15"
                d="M578.76,727.77c0-.81-.44-1.23-.6-1.37v-.03h2.41v-.68h-6.64v.68h3.4c.41.17.84.61.84,1.27s-.45.96-1.05.96h-3.19v.68h3.29c.97,0,1.55-.59,1.55-1.51h-.01Z"
              />
              <path
                class="four_st15"
                d="M574.81,733.73c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,732.41c0,.77-.45,1.12-1.27,1.12h-.27v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="four_st15"
                d="M578.71,737.83c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71-.01Z"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                class="four_st15"
                points="622.76 471.42 622.76 470.79 620.08 470.79 620.08 468.61 622.33 468.61 622.33 467.99 620.08 467.99 620.08 465.9 622.64 465.9 622.64 465.28 619.38 465.28 619.38 471.42 622.76 471.42 622.76 471.42"
              />
              <path
                class="four_st15"
                d="M627.13,467.31h-.04c-.17-.43-.55-.75-1.26-.75s-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0v.03Z"
              />
              <path
                class="four_st15"
                d="M634.44,470.52c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM633.12,467.16c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h-.01Z"
              />
              <path
                class="four_st15"
                d="M638.55,466.62c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.54c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h.01Z"
              />
              <path
                class="four_st15"
                d="M642.75,466.85c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h0ZM642.08,467.34v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
              />
              <path
                class="four_st15"
                d="M647.23,470.52c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM645.91,467.16c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h-.01Z"
              />
              <path
                class="four_st15"
                d="M652.56,468.13c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h.01Z"
              />
              <path
                class="four_st15"
                d="M653.73,469.1c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h-.01Z"
              />
              <path
                class="four_st15"
                d="M657.55,473.16c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h.02Z"
              />
              <path
                class="four_st15"
                d="M667.95,470.52c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM666.63,467.16c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h-.01Z"
              />
              <polygon
                class="four_st15"
                points="672.2 471.42 672.99 471.42 671.45 468.96 672.9 466.65 672.1 466.65 671.09 468.42 671.05 468.42 669.98 466.65 669.2 466.65 670.65 468.94 669.11 471.42 669.9 471.42 671.02 469.48 671.05 469.48 672.2 471.42 672.2 471.42"
              />
              <path
                class="four_st15"
                d="M674.11,471.42h.68v-4.76h-.68v4.76h0ZM673.91,465.27c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="four_st15"
                d="M677.77,471.46c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
            <g>
              <path
                class="four_st11"
                d="M605.25,460.63c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM603.94,467.48l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.67h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11.01-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0Z"
              />
              <polygon
                class="four_st15"
                points="580.47 468.98 580.47 483.15 575.92 479.81 574.17 482.19 581.94 487.89 581.94 487.88 581.94 487.89 589.71 482.19 587.97 479.81 583.42 483.15 583.42 468.98 595.39 468.98 595.39 466.03 580.47 466.03 580.47 468.98 580.47 468.98 580.47 468.98"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                class="four_st15"
                points="277.02 550.73 277.02 550.11 274.34 550.11 274.34 547.93 276.59 547.93 276.59 547.31 274.34 547.31 274.34 545.22 276.9 545.22 276.9 544.6 273.64 544.6 273.64 550.73 277.02 550.73 277.02 550.73"
              />
              <path
                class="four_st15"
                d="M281.39,546.63h-.04c-.17-.43-.55-.75-1.26-.75s-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0v.03Z"
              />
              <path
                class="four_st15"
                d="M288.7,549.84c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM287.38,546.48c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="four_st15"
                d="M292.81,545.94c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
              />
              <path
                class="four_st15"
                d="M297.01,546.17c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h.01ZM296.34,546.66v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
              />
              <path
                class="four_st15"
                d="M301.49,549.84c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM300.17,546.48c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="four_st15"
                d="M306.81,547.45c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h.01Z"
              />
              <path
                class="four_st15"
                d="M307.99,548.42c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h-.01Z"
              />
              <path
                class="four_st15"
                d="M311.81,552.48c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h.02Z"
              />
              <path
                class="four_st15"
                d="M322.21,549.84c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM320.89,546.48c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <polygon
                class="four_st15"
                points="326.46 550.73 327.25 550.73 325.71 548.27 327.16 545.97 326.36 545.97 325.35 547.74 325.31 547.74 324.24 545.97 323.45 545.97 324.91 548.26 323.37 550.73 324.16 550.73 325.28 548.8 325.31 548.8 326.46 550.73 326.46 550.73"
              />
              <path
                class="four_st15"
                d="M328.37,550.73h.68v-4.76h-.68v4.76h0ZM328.17,544.59c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="four_st15"
                d="M332.03,550.78c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h-.01Z"
              />
            </g>
            <g>
              <path
                class="four_st11"
                d="M259.51,539.95c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM258.2,546.8l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.66h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11,0-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0v-.02Z"
              />
              <polygon
                class="four_st15"
                points="234.73 548.3 234.73 562.46 230.18 559.13 228.43 561.51 236.2 567.2 236.2 567.2 236.2 567.2 243.97 561.51 242.23 559.13 237.68 562.46 237.68 548.3 249.65 548.3 249.65 545.35 234.73 545.35 234.73 548.3 234.73 548.3 234.73 548.3"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="four_st15"
                d="M613.67,764.52c-.77,0-1.4-.63-1.4-1.4v-9.3c0-.77.63-1.4,1.4-1.4s1.4.62,1.4,1.4v9.3c0,.77-.62,1.4-1.4,1.4h0Z"
              />
              <path
                class="four_st15"
                d="M620.34,759.43h-6.62c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h6.62c.53,0,.96.43.96.96s-.43.96-.96.96h0Z"
              />
              <path
                class="four_st15"
                d="M624.97,770.67c-.34,0-.68-.16-.89-.46l-4.08-5.69h-6.25c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1h6.81c.35,0,.69.17.89.46l3.77,5.26,2.2-1.55c.5-.35,1.18-.23,1.53.27.35.5.23,1.18-.27,1.53l-3.09,2.17c-.19.13-.41.2-.63.2h.01Z"
              />
              <path
                class="four_st15"
                d="M615.83,749.68c0,1.19-.96,2.15-2.15,2.15s-2.15-.96-2.15-2.15.96-2.15,2.15-2.15,2.15.96,2.15,2.15h0Z"
              />
              <path
                class="four_st15"
                d="M621.75,767.83c-1.17,1.92-3.28,3.2-5.68,3.2-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95,2.68,0,5.05-1.33,6.49-3.37l-.81-1.14h-.01Z"
              />
            </g>
            <g>
              <path
                class="four_st15"
                d="M600.17,780.18h1.53c1.79,0,2.56-1.13,2.56-3.12s-.79-3.01-2.55-3.01h-1.53v6.14h-.01ZM600.83,774.67h.81c1.24,0,1.93.64,1.93,2.47s-.6,2.43-1.88,2.43h-.85v-4.89h-.01Z"
              />
              <path
                class="four_st15"
                d="M605.67,780.18h.65v-4.76h-.65v4.76h0ZM605.49,774.04c0,.28.21.49.47.49.28,0,.48-.21.48-.49s-.21-.5-.48-.5-.47.21-.47.5h0Z"
              />
              <path
                class="four_st15"
                d="M610,778.92c0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26,0-.39.27-.71.89-.71.35,0,.72.16.93.38l.42-.47c-.28-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26h0v.02Z"
              />
              <path
                class="four_st15"
                d="M614.16,779.07c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07h0ZM613.22,775.35c-.94,0-1.37.55-1.53.78l.48.39c.13-.23.42-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.38.58.83.58.08,0,.18-.02.23-.05v-.5h-.12c-.32,0-.44-.29-.44-.72v-2.15c0-1-.57-1.44-1.54-1.44h0Z"
              />
              <path
                class="four_st15"
                d="M616.36,780.01c.28.15.71.25,1.28.25,1.5,0,2.23-1.07,2.23-2.62,0-1.63-.78-2.28-1.73-2.28-.57,0-.96.25-1.1.37h-.03v-2.21h-.64v6.48h-.01ZM617.73,779.67c-.28,0-.55-.05-.73-.13v-3.1c.21-.3.59-.47.95-.47.63,0,1.25.39,1.25,1.78,0,1.29-.59,1.93-1.48,1.93h0Z"
              />
              <path
                class="four_st15"
                d="M621.05,773.54v5.7c0,.62.3,1.01.92,1.01.18,0,.4-.03.57-.11v-.58c-.08.04-.21.1-.37.1-.34,0-.48-.18-.48-.6v-5.51h-.64Z"
              />
              <path
                class="four_st15"
                d="M626.29,779.29c-.19.17-.6.36-1.05.36-.91,0-1.38-.45-1.43-1.62h2.89c.03-.31.05-.59.05-.82,0-1.13-.58-1.86-1.65-1.86-1.01,0-1.93.71-1.93,2.43s.7,2.47,1.99,2.47c.65,0,1.12-.19,1.43-.43l-.29-.53h-.01ZM625.03,775.93c.73,0,1.07.45,1.07,1.27v.27h-2.28c.06-1.15.63-1.54,1.22-1.54h0Z"
              />
              <path
                class="four_st15"
                d="M630.57,775.5c-.21-.04-.46-.08-.72-.08-1.28,0-2.15.87-2.15,2.59,0,1.56.65,2.27,1.68,2.27.59,0,1.01-.3,1.18-.58h.03l.14.48h.48v-6.64h-.64v1.96h0ZM629.51,779.69c-.6,0-1.16-.43-1.16-1.76s.53-1.92,1.53-1.92c.21,0,.52.05.69.11v2.79c-.17.45-.52.77-1.06.77h0Z"
              />
              <path
                class="four_st15"
                d="M602.57,786.62l.93,4.06h.88l1.22-4.76h-.63l-.64,2.62c-.13.5-.24,1.02-.35,1.54h-.03c-.09-.48-.19-.91-.29-1.35l-.67-2.81h-.83l-.68,2.81c-.11.44-.2.88-.29,1.35h-.03c-.1-.53-.22-1.02-.34-1.53l-.63-2.63h-.67l1.2,4.76h.88l.97-4.06h.03-.03Z"
              />
              <path
                class="four_st15"
                d="M608.7,789.57c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07h0ZM607.76,785.85c-.94,0-1.37.55-1.53.78l.47.39c.13-.23.43-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.37.58.82.58.08,0,.18-.02.23-.05v-.5h-.12c-.32,0-.44-.29-.44-.72v-2.15c0-1-.58-1.44-1.54-1.44h.02Z"
              />
              <path
                class="four_st15"
                d="M613.04,789.42c0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26,0-.39.28-.71.89-.71.35,0,.72.16.93.38l.42-.47c-.27-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26h0v.02Z"
              />
              <path
                class="four_st15"
                d="M616.85,785.84c-.77,0-1.18.44-1.31.6h-.03v-2.41h-.65v6.64h.65v-3.4c.16-.41.58-.84,1.21-.84s.92.46.92,1.05v3.19h.65v-3.29c0-.97-.56-1.55-1.44-1.55h0Z"
              />
              <path
                class="four_st15"
                d="M621.91,785.89c-.1-.03-.25-.04-.46-.04-.53,0-.94.26-1.14.6h-.03l-.14-.53h-.49v4.76h.64v-3.55c.22-.43.67-.61,1.12-.61.17,0,.34.02.51.07v-.71h0Z"
              />
              <path
                class="four_st15"
                d="M623.08,788.26c0-1.23.33-1.84,1.18-1.84s1.24.62,1.24,1.9-.32,1.85-1.19,1.85-1.23-.63-1.23-1.91h0ZM624.26,790.76c1.38,0,1.91-1.02,1.91-2.49s-.48-2.43-1.86-2.43-1.9,1.01-1.9,2.48.48,2.45,1.85,2.45h0Z"
              />
              <path
                class="four_st15"
                d="M627.74,788.26c0-1.23.33-1.84,1.18-1.84s1.24.62,1.24,1.9-.32,1.85-1.19,1.85-1.23-.63-1.23-1.91h0ZM628.93,790.76c1.38,0,1.91-1.02,1.91-2.49s-.47-2.43-1.86-2.43-1.9,1.01-1.9,2.48.48,2.45,1.85,2.45h0Z"
              />
              <path
                class="four_st15"
                d="M635.05,786.58h-.03c-.17-.43-.53-.75-1.2-.75-.71,0-1.05.4-1.18.6h-.03l-.13-.51h-.5v4.76h.65v-3.4c.09-.41.46-.85,1.02-.85s.9.41.9,1.16v3.09h.65v-3.46c.12-.38.48-.8,1.04-.8s.89.38.89,1.11v3.14h.64v-3.28c0-1.04-.5-1.58-1.4-1.58-.71,0-1.15.37-1.33.75h0v.02Z"
              />
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  class="four_st15"
                  d="M569.2,781.13c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0s-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h.01Z"
                />
                <path
                  class="four_st15"
                  d="M569.2,775.24l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76s.11.08.18.08.13-.02.18-.08c.1-.1.1-.26,0-.36h-.01Z"
                />
                <path
                  class="four_st15"
                  d="M546.96,766.89c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM563.16,790.77h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="four_st15"
                  d="M556.85,771.37c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="four_st15"
                  d="M557.23,773.66h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h.02Z"
                />
              </g>
              <g>
                <path
                  class="four_st15"
                  d="M596.01,781.14c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0s-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h.01Z"
                />
                <path
                  class="four_st15"
                  d="M596.01,775.25l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76s.11.08.18.08.13-.02.18-.08c.1-.1.1-.26,0-.36h-.01Z"
                />
                <path
                  class="four_st15"
                  d="M573.77,766.9c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM589.97,790.78h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="four_st15"
                  d="M583.66,771.38c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="four_st15"
                  d="M584.04,773.67h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h.02Z"
                />
              </g>
            </g>
            <g>
              <polygon
                class="four_st15"
                points="562.23 755.48 562.23 761.62 565.57 761.62 565.57 761 562.93 761 562.93 755.48 562.23 755.48 562.23 755.48"
              />
              <path
                class="four_st15"
                d="M566.66,761.62h.68v-4.76h-.68v4.76h0ZM566.47,755.48c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="four_st15"
                d="M571.37,755c-.18-.06-.4-.11-.74-.11-.93,0-1.36.51-1.36,1.24v.72h-.8v.53h.79v4.23h.68v-4.23h1.24v-.53h-1.23v-.73c0-.43.17-.64.63-.64.27,0,.46.03.64.09l.14-.58h0Z"
              />
              <path
                class="four_st15"
                d="M573.47,761.66c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <polygon
            class="four_st12"
            points="521.87 521.78 527.92 521.96 533.85 521.71 539.78 521.89 545.7 521.68 551.63 522.01 557.56 521.67 563.25 522.03 563.52 527.82 563.28 533.78 563.68 539.74 563.18 545.69 563.61 551.65 563.38 557.6 563.6 563.65 557.56 563.44 551.63 563.65 545.7 563.51 539.78 563.68 533.85 563.54 527.92 563.68 522.06 563.51 521.66 557.6 522.06 551.65 521.98 545.69 522.22 539.74 521.93 533.78 522.34 527.82 521.87 521.78 521.87 521.78"
          />
          <g>
            <polygon
              class="four_st2"
              points="521.87 521.78 527.92 521.96 533.85 521.71 539.78 521.89 545.7 521.68 551.63 522.01 557.56 521.67 563.25 522.03 563.52 527.82 563.28 533.78 563.68 539.74 563.18 545.69 563.61 551.65 563.38 557.6 563.6 563.65 557.56 563.44 551.63 563.65 545.7 563.51 539.78 563.68 533.85 563.54 527.92 563.68 522.06 563.51 521.66 557.6 522.06 551.65 521.98 545.69 522.22 539.74 521.93 533.78 522.34 527.82 521.87 521.78 521.87 521.78"
            />
            <path
              class="four_st10"
              d="M540.15,538.2c0-.3,4.24-4.21,6.47-1.06.47.66,1.57,2.21,1.62,3.55.05,1.26-1.68,1.83-2.18,2.63-1.3,2.11-2.89.88-4.54-.11-1.12-.67-2.64-.2-2.72-2.52-.05-1.38,1.41.07,1.35-2.48h0Z"
            />
            <path
              class="four_st10"
              d="M525.68,555.28c7.43-10.85,6.18,6.42-.26,2.82-.76-.42-.19-2.16.26-2.82h0Z"
            />
            <path
              class="four_st10"
              d="M534.55,527.89c-1.12-1.87-4.36.02-6.64.9-1.85.72-2.92.17-2.86,1.42.06,1.18-.02,5.42,4.39,5.71,1.41.09,3.68-2.42,6.05-2.71,3.89-.48-.52-4.62-.94-5.32h0Z"
            />
            <path
              class="four_st10"
              d="M557.53,524.65c-14.16-2.84,4,17.9,2.68,3.32-.03-.38-2.21-3.22-2.68-3.32h0Z"
            />
            <path
              class="four_st10"
              d="M539.4,551.19c-7.02-3.62-.19,12.47,3.64,5.76,1.72-3.03-1.61-4.71-3.64-5.76h0Z"
            />
            <path
              class="four_st10"
              d="M552.85,556.61c-6.5,4.49,10.91,6.03,6.79-.5-1.86-2.95-4.91-.8-6.79.5h0Z"
            />
            <path
              class="four_st10"
              d="M558.07,544.24c6.59,11.38-8.45,2.81-2.43-1.45.71-.5,2.03.76,2.43,1.45h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="four_st12"
            points="370.61 455.73 328.89 453.27 286.36 455.46 243.83 454.27 200.45 455.39 202.49 412.93 200.37 371.07 201.77 329.21 200.14 287.35 201.48 245.49 200.07 203.63 201.76 162.1 249.57 162.69 273.72 162.57 297.83 164.04 322 162.88 346.09 165.25 370.29 162.9 370.61 162.99 371.25 183.06 369.7 220.17 371.47 255.5 369.7 295.5 371.03 335.06 369.66 375.98 371.57 415.86 370.61 455.73"
          />
          <polyline
            class="four_st6"
            points="370.61 455.8 328.89 453.34 286.36 455.52 243.83 454.34 200.45 455.45 202.49 413 200.37 371.14 201.77 329.28 200.14 287.42 201.48 245.56 200.07 203.7 201.76 162.16 249.57 162.76 273.72 162.64 297.83 164.11 322 162.95 346.09 165.31 370.29 162.97 370.61 163.05"
          />
        </g>
        <g>
          <polyline
            class="four_st5"
            points="692.36 790.34 701.63 790.32 716.49 789.87 731.36 790.52 746.03 789.77"
          />
          <g id="Tower">
            <g>
              <polyline
                class="four_st5"
                points="995.33 456.04 998.03 594.63 995.46 692.3 997.65 790.56 930.68 789.13 864.61 790.81 744.74 790.06"
              />
              <polyline
                class="four_st5"
                points="441 16.73 484.34 18.12 541.2 16.21 598.06 18.12 654.92 16.21 711.79 18.12 768.65 16.21 825.51 18.12 882.37 16.21 939.23 18.12 996.77 16.49 995.14 57.04 997.05 96.91 995.14 136.79 997.05 176.67 995.14 216.54 997.05 256.42 995.14 296.29 997.05 336.17 995.14 376.05 997.05 415.92 995.14 455.8"
              />
              <polyline
                class="four_st5"
                points="369.66 455.8 371.57 415.92 369.66 376.05 371.57 336.17 369.66 296.29 371.57 256.42 369.66 216.54 371.57 176.67 369.66 136.79 371.57 96.91 369.66 57.04 371.29 17.84 407.14 17.79"
              />
            </g>
            <g>
              <g>
                <path
                  class="four_st14"
                  d="M429.24,33.01c-.06-.79-.16-1.71-.39-2.54l-.05-.17-.2-.04c-.48-.11-.95-.14-1.46-.16.04-.03.07-.07.1-.11.07-.11.1-.23.1-.38,0-.12,0-.25-.07-.4l-.06-.13-.2-.03s-.02-.01-.02-.02c0-.84-.02-1.85-.03-2.9v-1.34c.12-.08.21-.19.26-.31.08-.21.09-.4,0-.57l-.07-.14-.2-.02s-.02-.01-.02-.03c-.01-1.48-.02-2.47-.01-3.13,0-.17.01-.38.02-.65v-.02c.11-.04.21-.09.29-.16.06-.05.12-.11.18-.19.03-.05.12-.2.05-.36l-.04-.09-.1-.04c-.13-.06-.27-.07-.39-.08v-1.55c0-.81-.01-1.72-.01-2.57,0-.01,0-.02.01-.02.1-.04.18-.09.26-.13l.13-.07v-.39c0-.1-.05-.18-.12-.23-.1-.08-.22-.09-.27-.09h0c.02-1.05.05-1.75.12-2.13v-.02c.08-.83.14-1.65.1-2.46v-.14c-.01-.26-.03-.64-.49-.9-.27-.11-.58-.14-.85-.16-.11,0-.21-.02-.33-.03h-.02c-.65-.05-1.35-.09-2.07-.09-.93,0-1.72.07-2.43.21l-.11.02-.07.07c-.13.13-.13.27-.13.34,0,.06,0,.11.01.15v.04c0,.47.1.94.18,1.39.04.21.08.43.11.64-.07.03-.12.06-.17.1-.23.18-.23.43-.22.59v.28l.26.02h.17v.02l-.03.52c-.07,1.2-.12,2.29-.12,3.4,0,0,0,.01-.02.02-.21.1-.36.25-.44.42l-.05.13.06.08c0,.06.01.22.18.32.09.05.18.06.23.06h.04c0,.74.01,2.1.01,3.49,0,.01,0,.02-.02.03-.23.05-.42.15-.55.28-.09.09-.14.19-.15.3l-.02.15c-.01.09.01.17.07.22.09.1.22.11.27.11l.29.02v.06l-.02.22.14.03v3.79s0,.02-.01.02c-.1.03-.19.08-.28.14-.1.08-.32.24-.32.48v.47h.44v.25l.17.02v2.39c-.05.31.01.57.19.78v.03s-.02.01-.02.01c-.35.02-.68.04-.98.07h-.03c-.21.02-.37.03-.48.04h-.06c-.19,0-.46.04-.63.18-.11.1-.16.22-.15.35v.48c-.01.47-.02,1.05,0,1.33v.05c-.01.19-.02.5.23.67.06.04.17.1.33.1h9.96l-.02-.34.04-.05ZM420.89,20.88v.02h-.06s.04-.03.07-.04h0v.02ZM423.62,8.71c.58,0,1.17.03,1.75.08.1.02.23.03.36.04.14.01.44.04.5.06.06.03.06.22.07.34v.11c0,.1.01.2.02.3.01.17.02.32,0,.43-.07.3-.06.6-.06.89,0,.25.01.49-.03.71-.14.54-.11,1.08-.08,1.61,0,.07,0,.14.01.21v.02h-.02l-.28-.04s-.02-.01-.02-.03v-.08c0-.14-.11-.26-.25-.27l-.64-.08s-.09-.01-.14-.02l.3-.28-.59-.05c-.18-.02-.36-.04-.54-.06-.01,0-.02-.01-.02-.03v-.03c0-.14-.11-.26-.25-.28l-.67-.08v-.03l.05-.26-1.07-.12s-.02-.01-.02-.03v-.4h-.13c-.02-.41-.09-.81-.17-1.25-.08-.43-.17-.87-.17-1.29.69-.07,1.39-.11,2.09-.11v.02ZM426.18,29.43v.63h-.03c-.76-.04-1.56-.06-2.36-.06h-.25c-.29-.03-.59-.05-.88-.07-.32-.05-.87-.12-.93-.31-.02-.1-.02-.84-.03-1.25v-1.13c.13,0,.26.02.39.03.01,0,.02.01.02.03v.28l.25.03c.19.02.39.04.58.05.01,0,.02.01.02.02v.06c.02.13.13.23.26.24l.59.06s.02.01.02.03c0,.14.12.26.26.27l.58.04s.02,0,.02.02l.02.1c.02.12.12.22.24.23l.46.06s.01.07.02.1v.23l.27.02c.11,0,.23.02.35.04.02,0,.07.01.11.02l-.07.2.09.02h0ZM426.15,28.7s-.11-.02-.16-.02c-.01,0-.02,0-.02-.01-.02-.07-.05-.13-.08-.19l-.07-.12-.55-.07-.02-.1c-.01-.09-.06-.16-.12-.21-.09-.06-.19-.07-.23-.07l-.49-.03v-.02c0-.14-.12-.25-.25-.27l-.61-.06s-.02-.01-.02-.02l-.04-.31h-.25c-.17-.01-.35-.02-.52-.04-.01,0-.02-.01-.02-.03v-.26l-.24-.04c-.14-.02-.3-.04-.45-.06-.02,0-.03-.01-.02-.03,0-.15-.1-.27-.25-.29h-.03s-.02-.02-.02-.03c-.01-1.34-.02-2.76-.02-4.31.02,0,.05.02.07.02l.45.07s.02.01.02.03c0,.05,0,.1.01.16l.04.21.74.02s.04.09.08.14c.07.07.16.1.27.1h.25s.01.1.05.15c.09.13.25.14.3.15l.39.04-.27.23.63.05c.15.01.31.03.47.04l-.23.23.6.02c.15,0,.3.02.44.04,0,.08.01.2.14.29.04.03.09.05.13.06,0,.68-.01,2.29-.01,2.29,0,.8,0,1.57-.01,2.24h-.08ZM426.07,23.34c-.1-.02-.19-.03-.29-.04-.04-.07-.09-.12-.17-.16-.13-.07-.27-.09-.4-.1l-.22-.02s-.02-.01-.02-.02c-.04-.06-.09-.12-.15-.16-.14-.09-.31-.11-.42-.12l-.19-.02s0-.11-.05-.17c-.07-.1-.18-.14-.27-.15-.05-.01-.11-.02-.17-.02h-.17v-.23l-.77-.02s0-.03.01-.04l.09-.27-.82-.13h0s0-.14-.09-.23c-.08-.07-.17-.09-.21-.09l-.11-.02c0-1.24,0-2.59.02-4.11,0-.02.01-.02.03-.02h.06s.02.02.02.03v.12c.03.13.12.23.25.25l.73.11s.02.01.02.03v.02c0,.14.11.25.24.27l.7.1v.25l.81.12s.02.01.02.03c.03.09.1.16.19.2.08.04.16.05.21.05l.44.05s.03.08.04.11l.06.13.16.03c.16.02.32.04.48.06l.08.09.02,1.32c-.01.61-.02,1.5-.03,2.8-.05-.01-.09-.03-.15-.03h.02ZM425.36,13.85c.09.08.21.1.26.1l.38.05.02.09c.01.09.05.17.13.22.01,0,.02.01.03.02l.05,4.29v.02h-.02c-.08,0-.16-.02-.25-.03v-.04l-.02-.21-.77-.08.07-.21-.9-.13v-.25l-.94-.13s-.02-.01-.02-.04c0-.14-.1-.25-.24-.27l-.74-.11s-.02-.01-.02-.02v-.13c-.03-.13-.13-.23-.26-.25l-.41-.05s-.02-.01-.02-.03v-.22c-.01-1.15.06-2.33.13-3.47.01-.23.03-.45.04-.67,0-.01.01-.02.03-.02l.6.06s.02.1.03.14l.05.16.8.1s.02.01.02.03v.26l.24.04c.17.03.35.05.52.07l.07.05c.04.07.1.14.18.19.16.1.35.12.48.14l.39.05v.04s0,.15.11.25h-.02ZM428.43,32.7h-.02c-.87-.06-1.88-.07-2.67-.07h-3.66c-.81,0-1.78.02-2.58.05v-.18c-.03-.25-.05-.85-.06-1.7h.11l.6-.03c.91-.04,2.01-.07,3.09-.07h.32c.95.07,1.84.1,2.7.11h.07c.14,0,.25-.02.37-.07.65.01,1.14.04,1.51.09v.02c.09.55.21,1.23.24,1.83v.02h-.02Z"
                />
                <polygon
                  class="four_st8"
                  points="426.98 2.39 421.13 2.39 415.57 4.2 410.84 7.63 407.4 12.37 405.59 17.93 405.59 23.78 407.4 29.34 410.84 34.07 415.57 37.51 421.13 39.31 426.98 39.31 432.54 37.51 437.27 34.07 440.71 29.34 442.52 23.78 442.52 17.93 440.71 12.37 437.27 7.63 432.54 4.2 426.98 2.39"
                />
              </g>
              <g>
                <polygon
                  class="four_st15"
                  points="407.62 56.82 408.79 56.82 408.79 47.63 411.5 47.63 411.5 46.59 404.89 46.59 404.89 47.63 407.62 47.63 407.62 56.82 407.62 56.82"
                />
                <path
                  class="four_st15"
                  d="M413.07,52.78c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.55,3.08-2.09,3.08-2.16-1.05-2.16-3.18h0ZM415.15,56.95c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
                />
                <path
                  class="four_st15"
                  d="M424.67,50.05l1.62,6.77h1.53l2.13-7.94h-1.09l-1.12,4.36c-.22.83-.42,1.71-.61,2.57h-.06c-.16-.8-.34-1.52-.51-2.25l-1.17-4.68h-1.46l-1.2,4.68c-.19.73-.35,1.47-.51,2.25h-.06c-.18-.87-.38-1.71-.6-2.55l-1.11-4.38h-1.17l2.1,7.94h1.53l1.69-6.77h.07Z"
                />
                <path
                  class="four_st15"
                  d="M436.39,55.33c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.87h0ZM434.18,49.73c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
                />
                <path
                  class="four_st15"
                  d="M443.23,48.82c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.95-1.02.29,0,.6.03.89.12v-1.18h0Z"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <polygon
            class="four_st12"
            points="539.93 691.7 539.96 662.78 539.45 648.46 540.9 634.13 539.1 619.81 539.2 588.65 538.59 560.05 496.26 560.05 470.81 561.06 428.99 560.05 387.66 561.06 385.68 593.36 388.82 625.91 387.17 658.47 389.07 691.02 386.73 723.58 388.91 756.13 387.2 788.74 401.25 790.2 415.36 790.11 429.55 789.02 445.45 790.2 461.7 790.29 461.26 691.84 539.93 691.7"
          />
          <polyline
            class="four_st4"
            points="463.22 789.68 445.45 790.2 429.55 789.02 415.36 790.11 401.25 790.2 387.2 788.74 388.91 756.13 386.73 723.58 389.07 691.02 387.17 658.47 388.82 625.91 385.68 593.36 387.66 561.06 428.99 560.05 470.81 561.06 496.26 560.05 538.59 560.05 539.2 588.65 539.1 619.81 540.9 634.13 539.45 648.46 539.96 662.78 539.93 691.7"
          />
          <g>
            <path
              class="four_st13"
              d="M462.21,628.71c-.14,0-.3-.02-.44-.03-.12,0-.2-.11-.2-.23.07-1.8.61-12.49.61-12.62,0-.09,0-.17,0-.26h0c.01-.54.03-1.05.04-1.55v-.04c.1-3.2.2-6.52-.49-9.74,0-.04-.02-.09-.03-.14v-.02s0,0,0,0c-.06-.27.32-.39.42-.13.02.04.03.09.05.13.29.82.52,1.7.68,2.64l.06.44c.37,2.76.76,5.6.66,8.41,0,0,0,0,0,.01,0,.1-.01.18-.02.26-.01.17-.08.95.09.98h.22c3.17.16,6.37.36,9.79.64h.1c.26.03.51.05.77.07.12.01.21.11.2.23,0,.21-.02.42-.03.62v.09c-.06,1.51-.05,3.07,0,4.76.03.5.06,1.01.1,1.5.09,1.22.19,2.49.13,3.74v.02s0,.02,0,.03c-.01,0-.03,0-.05,0h-.03s0,0,0,0c-.03,0-.12.01-.22.02h-.12s-.07,0-.13,0c-.03,0-.08,0-.13,0-.11,0-.2-.1-.2-.21v-.08c-.01-.32-.03-.65-.02-.95.02-.61.05-1.23.08-1.84v-.2c.11-2.22.22-4.51.09-6.77v-.18c-.02-.12-.12-.21-.23-.21h-.18c-2.54.06-4.92.09-7.25.09-.93,0-1.87,0-2.78-.01h-.16c-.11,0-.2.08-.22.18l-.02.16c-.39,2.39-.65,6.39-.8,8.78-.03.45-.06.89-.08,1.21,0,.12-.11.21-.23.2h0Z"
            />
            <g>
              <polygon
                class="four_st16"
                points="419.94 651.83 421.11 651.83 421.11 642.61 423.84 642.61 423.84 641.57 417.2 641.57 417.2 642.61 419.94 642.61 419.94 651.83 419.94 651.83"
              />
              <path
                class="four_st16"
                d="M429.21,643.81c-.18-.04-.44-.07-.81-.07-.92,0-1.66.44-2.01,1.01h-.06l-.25-.88h-.86v7.97h1.13v-5.93c.38-.72,1.19-1.03,1.96-1.03.29,0,.6.03.89.12v-1.19h0Z"
              />
              <path
                class="four_st16"
                d="M434.34,649.97c-.37.54-1.08,1.08-1.99,1.08s-1.44-.57-1.44-1.27c0-1.2,1.51-1.67,3.43-1.6v1.79h0ZM432.68,643.75c-1.65,0-2.4.92-2.68,1.3l.84.66c.23-.38.75-.97,1.82-.97s1.68.38,1.68,1.68v.86c-2.83-.04-4.56.82-4.56,2.58,0,1.08.82,2.12,2.3,2.12,1.35,0,1.99-.63,2.37-1.07h.06c.19.54.66.97,1.45.97.15,0,.31-.03.41-.09v-.84h-.21c-.56,0-.78-.48-.78-1.2v-3.6c0-1.67-1.01-2.42-2.71-2.42h0Z"
              />
              <path
                class="four_st16"
                d="M438.59,651.83h1.14v-7.97h-1.14v7.97h0ZM438.26,641.55c0,.47.37.82.82.82.48,0,.85-.35.85-.82s-.37-.83-.85-.83c-.45,0-.82.35-.82.83h0Z"
              />
              <path
                class="four_st16"
                d="M448.46,646.34c-.04-1.77-1-2.64-2.59-2.64-1.25,0-2.05.72-2.27,1h-.06l-.23-.84h-.86v7.97h1.14v-5.7c.28-.78,1.04-1.42,2.02-1.42,1.11,0,1.71.67,1.71,1.89v5.23h1.14v-5.49h0Z"
              />
              <path
                class="four_st16"
                d="M451.23,651.83h1.14v-7.97h-1.14v7.97h0ZM450.9,641.55c0,.47.37.82.82.82.48,0,.85-.35.85-.82s-.37-.83-.85-.83c-.45,0-.82.35-.82.83h0Z"
              />
              <path
                class="four_st16"
                d="M461.1,646.34c-.04-1.77-1-2.64-2.59-2.64-1.25,0-2.05.72-2.27,1h-.06l-.23-.84h-.86v7.97h1.14v-5.7c.28-.78,1.04-1.42,2.02-1.42,1.11,0,1.71.67,1.71,1.89v5.23h1.14v-5.49h0Z"
              />
              <path
                class="four_st16"
                d="M469.21,644.2c-.48-.23-1.26-.41-2.27-.41-2.64,0-3.88,1.71-3.88,4.26,0,2.71,1.39,3.73,3.03,3.73,1.03,0,1.7-.41,1.95-.63h.06v.73c0,1.42-.59,2.12-2.04,2.12-1.07,0-1.7-.35-2.1-.75l-.66.91c.32.32,1.11.85,2.62.85,1.99,0,3.28-1.04,3.28-3.13v-7.69h0ZM468.09,645.01v5.01c-.38.5-1.05.78-1.68.78-1.13,0-2.18-.6-2.18-2.89,0-2.11,1.03-3.12,2.56-3.12.51,0,.97.09,1.3.22h0Z"
              />
              <path
                class="four_st16"
                d="M479.85,643.81c-.18-.04-.44-.07-.81-.07-.92,0-1.66.44-2.01,1.01h-.06l-.25-.88h-.86v7.97h1.13v-5.93c.38-.72,1.19-1.03,1.96-1.03.29,0,.6.03.89.12v-1.19h0Z"
              />
              <path
                class="four_st16"
                d="M481.9,647.78c0-2.07.57-3.08,2.08-3.08s2.18,1.04,2.18,3.18-.56,3.09-2.1,3.09-2.17-1.05-2.17-3.19h0ZM483.98,651.97c2.42,0,3.35-1.71,3.35-4.17s-.84-4.07-3.27-4.07-3.34,1.68-3.34,4.15.83,4.1,3.25,4.1h0Z"
              />
              <path
                class="four_st16"
                d="M490.09,647.78c0-2.07.57-3.08,2.08-3.08s2.18,1.04,2.18,3.18-.56,3.09-2.1,3.09-2.17-1.05-2.17-3.19h0ZM492.17,651.97c2.42,0,3.35-1.71,3.35-4.17s-.84-4.07-3.27-4.07-3.34,1.68-3.34,4.15.83,4.1,3.25,4.1h0Z"
              />
              <path
                class="four_st16"
                d="M502.93,644.96h-.06c-.29-.72-.92-1.26-2.11-1.26-1.24,0-1.85.67-2.07,1.01h-.06l-.24-.85h-.88v7.97h1.14v-5.7c.16-.69.81-1.42,1.8-1.42s1.58.69,1.58,1.95v5.17h1.14v-5.79c.21-.65.84-1.33,1.83-1.33s1.57.63,1.57,1.86v5.26h1.13v-5.49c0-1.74-.88-2.64-2.46-2.64-1.24,0-2.02.62-2.33,1.26h0Z"
              />
              <path
                class="four_st16"
                d="M514.94,650.78c.12-.09,1.35-1.39,1.43-1.48.12-.12,1.29-1.45,1.38-1.55.88-1.04,1.36-2.04,1.36-3.12,0-1.45-1-2.42-2.64-2.42s-2.49.97-2.74,2.11l1.16.26c.15-.7.56-1.38,1.49-1.38s1.54.59,1.54,1.54c0,.82-.29,1.49-1,2.3-.16.23-2.99,3.41-3.37,3.76l.19,1.03h5.54v-1.03h-2.86l-1.49.03v-.06h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              class="four_st12"
              points="517.98 736.77 516.84 740.71 461.7 742.18 461.7 693.07 539.3 693.07 539.3 733.32 517.98 736.77"
            />
            <polygon
              class="four_st12"
              points="539.08 788.87 461.26 788.87 461.26 743.13 515.14 744.09 516.68 745.59 529.36 745.05 530.92 744.37 539.08 744.51 539.08 788.87"
            />
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    class="four_st15"
                    d="M476.74,707.74c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M480.44,718.63l-1.55-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9s.97-.19,1.07-.61l1.56-6.74v-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.06,0-.11-.03-.16l-1.9-9.83h.32v.04l1.56,6.74c.08.37.46.62.89.62.06,0,.12,0,.18-.01.49-.08.81-.48.72-.9h-.02Z"
                  />
                </g>
                <g>
                  <polygon
                    class="four_st15"
                    points="487.83 709.78 487.83 715.92 491.16 715.92 491.16 715.3 488.53 715.3 488.53 709.78 487.83 709.78 487.83 709.78"
                  />
                  <path
                    class="four_st15"
                    d="M494.49,714.81c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM493.5,711.09c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h-.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M499.56,711.23c-.22-.04-.48-.08-.76-.08-1.34,0-2.26.87-2.26,2.59,0,1.56.68,2.27,1.76,2.27.62,0,1.06-.3,1.24-.58h.04l.15.48h.51v-6.64h-.67v1.96h0ZM498.45,715.43c-.63,0-1.22-.43-1.22-1.76s.55-1.92,1.6-1.92c.22,0,.54.05.73.11v2.79c-.18.45-.54.77-1.11.77h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M501.92,715.92h.68v-4.76h-.68v4.76h0ZM501.73,709.77c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M507.25,715.02c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM505.93,711.66c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M511.21,714.66c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M490.35,722.36l.97,4.06h.92l1.28-4.76h-.66l-.67,2.62c-.13.5-.25,1.02-.37,1.54h-.04c-.1-.48-.2-.91-.31-1.35l-.7-2.81h-.88l-.72,2.81c-.11.44-.21.88-.31,1.35h-.04c-.11-.53-.23-1.02-.36-1.53l-.67-2.63h-.7l1.26,4.76h.92l1.01-4.06h.07Z"
                  />
                  <path
                    class="four_st15"
                    d="M496.79,725.31c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM495.8,721.59c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h-.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M501.34,725.16c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M505.34,721.58c-.81,0-1.23.44-1.37.6h-.03v-2.41h-.68v6.64h.68v-3.4c.17-.41.61-.84,1.27-.84s.96.45.96,1.05v3.19h.68v-3.29c0-.97-.59-1.55-1.51-1.55h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M510.65,721.62c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M511.88,724c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h.01ZM513.12,726.5c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M516.77,724c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h.01ZM518.02,726.5c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M524.45,722.32h-.04c-.17-.43-.55-.75-1.26-.75s-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0v.03Z"
                  />
                </g>
              </g>
              <g>
                <path
                  class="four_st15"
                  d="M476.71,756.18c0,1.23-1,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
                />
                <path
                  class="four_st15"
                  d="M477.18,759.02h-5.39c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.47c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h0Z"
                />
                <g>
                  <path
                    class="four_st15"
                    d="M490.17,758.16c-1.46,0-2.63.96-2.63,3.18,0,2.09.84,3.13,2.42,3.13.95,0,1.53-.23,1.93-.55v-2.65h-.7v2.35c-.25.17-.68.24-1.08.24-1.2,0-1.86-.74-1.86-2.58,0-2,.98-2.48,1.87-2.48.61,0,1.02.17,1.28.42l.46-.53c-.2-.19-.67-.53-1.69-.53h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M496.33,763.49c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM495,760.13c.77,0,1.12.45,1.12,1.27v.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M501.65,761.1c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M504.44,764.43c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h-.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M508.65,763.12c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M490.35,770.82l.97,4.06h.92l1.28-4.76h-.66l-.67,2.62c-.13.5-.25,1.02-.37,1.54h-.04c-.1-.48-.2-.91-.31-1.35l-.7-2.81h-.88l-.72,2.81c-.11.44-.21.88-.31,1.35h-.04c-.11-.53-.23-1.02-.36-1.53l-.67-2.63h-.7l1.26,4.76h.92l1.01-4.06h.07Z"
                  />
                  <path
                    class="four_st15"
                    d="M496.79,773.77c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM495.8,770.05c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h-.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M501.34,773.63c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M505.34,770.05c-.81,0-1.23.44-1.37.6h-.03v-2.41h-.68v6.64h.68v-3.4c.17-.41.61-.84,1.27-.84s.96.45.96,1.05v3.19h.68v-3.29c0-.97-.59-1.55-1.51-1.55h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M510.65,770.09c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                  />
                  <path
                    class="four_st15"
                    d="M511.88,772.46c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h.01ZM513.12,774.96c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M516.77,772.46c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h.01ZM518.02,774.96c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h.01Z"
                  />
                  <path
                    class="four_st15"
                    d="M524.45,770.78h-.04c-.17-.43-.55-.75-1.26-.75s-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0v.03Z"
                  />
                </g>
              </g>
            </g>
            <path
              class="four_st7"
              d="M515.49,742.8h-53.8v-49.84h77.79v40.95l-21.6.31M516.82,742.99l-7.87-.32-7.87.35-7.87-.24-7.87.29-7.87-.47-7.87.49-8.21-.52.39,6.97-.34,6.74.57,6.74-.72,6.74.63,6.74-.34,6.74.32,6.62,10.94.28,11.11-.29,11.11.19,11.11-.23,11.11.19,11.11-.2,11.44-.28-.43-6.18.48-6.11-.42-4.55.03-6.56.47-5.89-.78-5.56.82-5.13-.68-6.61-1.14-.36-1.32.31-2.64.25-2.64.02-1.32-.52"
            />
          </g>
        </g>
        <g>
          <a href="/library" alt="library" className="highlight">
            <g id="library">
              <title> Library</title>
              <polygon
                class="four_st12"
                points="693.63 790.13 643.03 790.13 642.42 743.29 599.12 743.14 601.05 579.09 600.78 557.3 599.31 497.34 698.24 497.34 694.63 557.37 694.93 579.19 698.53 655.71 696.03 687.53 698.53 715.25 693.63 790.13"
              />
              <g>
                <polygon
                  class="four_st17"
                  points="608.99 512.14 611.25 512.14 611.25 509.74 613.65 509.74 613.65 507.48 611.25 507.48 611.25 505.08 608.99 505.08 608.99 507.48 606.59 507.48 606.59 509.74 608.99 509.74 608.99 512.14 608.99 512.14"
                />
                <path
                  class="four_st1"
                  d="M697.4,579.18l1.04,80.7-2.41,27.72,2.5,27.72-2.66,26.85-2.03,49.25-50.96.15.15-13.19-.44-14.22v-8.89l-.67-13.93-4.44-.22-11.33.44-8.67.22-10,.22-8.7.07,1.07-34.16-1.62-35.12,1.08-35.12-.74-58.48M598.3,557.42l-.32-25.13,1.32-34.89,20.55-1.49,21.13,1.51,21-.31,21.01.88,16.34-.39-2.49,38.54.27,21.27"
                />
              </g>
            </g>
          </a>
          <g>
            <path
              class="four_st13"
              d="M665.76,617.28c.06,1.26.18,3.6.04,7.57-.05,1.26-.16,2.55-.29,3.91-.13,1.4-.26,2.84-.31,4.29l-.05,1.49-.31-.12-.31-.13c-.87-.37-1.78-.76-2.71-.96-1.07-.24-2.1-.33-2.96-.39l-2.59-.13c-.88-.04-1.67-.15-2.37-.25-.41-.06-.79-.11-1.13-.14.51-.14,1.13-.3,1.86-.42.92-.15,1.77-.23,2.6-.23.51,0,1.02.03,1.51.08.78.09,1.58.25,2.38.5.28.09.57.19.87.29l.41.14.68.22.09.03c.09.03.18.05.3.08.09.02.17.03.26.03.18,0,.35-.04.49-.13.31-.17.42-.48.45-.57.05-.17.07-.32.07-.45l.09-1.86.11-2.55c.04-.92-.09-1.84-.2-2.73-.11-.81-.22-1.65-.21-2.47.02-1.34.12-2.71.21-4.02.13-1.93.25-3.76.18-5.52.24.21.52.45.81.7.13.12.16.17.16.19.02.14-.08,1.54-.11,2-.02.28-.03.5-.04.58,0,.21,0,.52.03,1h0ZM651.68,631.77c-.1.04-.19.07-.28.1-.2.07-.36.13-.49.19,0,0-.02,0-.03.01,0-.15,0-.35,0-.63,0-.5-.01-1.24-.04-2.2l-.09-3.11c0-.24-.01-.47-.02-.72v-.05c-.03-.91-.06-1.86-.02-2.8.03-.79.14-1.59.23-2.37.05-.4.1-.82.15-1.23.11-1.06.16-2.18.16-3.35,0-1.65-.1-2.93-.14-3.48,0,0-.01-.2-.02-.26-.03-.46-.04-.88-.04-1.22,0-.12,0-.24,0-.34.17-.06.39-.14.63-.23.83-.31,2.09-.77,3.57-1.08l.08-.02c.47-.1,1.71-.37,3.53-.37h.16c1.2.02,2.35.16,3.42.41.26.07.4.15.47.25.11.15.18.47.26.77.14.61.25,1.32.33,2.15.16,1.87.04,3.88-.08,6-.08,1.34-.16,2.72-.17,4.09,0,.88.12,1.74.24,2.58.13.85.25,1.73.23,2.59l-.08,2.55-.04,1.23c0,.11-.01.23-.01.35,0,.07,0,.21-.01.31-.06-.02-.13-.04-.19-.05l-.65-.2-.39-.12c-.28-.09-.6-.19-.92-.29-.87-.25-1.74-.42-2.59-.5-.44-.04-.88-.06-1.33-.06-.99,0-1.99.1-3.07.31-1.29.26-2.17.49-2.78.73h0ZM645.6,632.07c-1.41.17-3.11.53-5.03,1.07l-2.8.8-1.45.41-.78.2.04-1.09.2-5.36c.05-1.4.01-2.73-.02-4.02-.02-.87-.05-1.69-.04-2.49v-1.68c.04-3.13.06-5.39.02-5.9l-.03-.4s0-.16-.03-.26l-.03-.15.12-.3c.13-.25.39-.48.65-.69.13-.1.26-.19.37-.27v.72c0,1.32.07,2.35.13,3.35.09,1.34.17,2.61.1,4.54-.03.91-.19,2.37-.34,3.81-.13,1.26-.26,2.44-.3,3.24l-.15,2.52c-.01.23-.04.47-.06.71-.1.99-.17,1.7.31,1.96.06.03.13.05.2.05.24,0,.44-.18.92-.61.44-.4,1.03-.94,1.49-1.13.48-.19,1.03-.28,1.69-.28.25,0,.53.01.84.04.39.04.77.08,1.15.12h.06c1.28.13,2.49.26,3.48.48.57.13,1.08.31,1.54.48-.05,0-.09,0-.14,0-.68,0-1.39.04-2.11.13h0ZM637.93,624.5c.16-1.45.33-2.95.37-3.89.09-1.99.02-3.35-.04-4.67-.05-.98-.1-1.99-.09-3.27v-2.28c.01-.12.01-.25.03-.32.01-.06.01-.06.06-.11.05-.06.17-.14.26-.21l.03-.02c.06-.05.14-.1.22-.15.04-.02.08-.05.1-.06.72-.39,1.56-.58,2.65-.58.12,0,.24,0,.36,0,.93.04,1.71.17,2.34.27l1.32.24c.57.11,1.12.22,1.62.32l.1.02c1.11.22,2.02.4,2.59.48-.12.34-.26.94-.2,1.72,0,.07.01.19.03.36.05.58.14,1.78.18,3.29.02,1.12,0,2.2-.09,3.21-.03.38-.07.76-.11,1.17-.08.82-.17,1.66-.19,2.51-.02,1.03.05,2.02.11,2.99.01.22.03.44.04.66l.21,3.11c.07.97.12,1.69.17,2.19.01.13.02.24.03.34-.13-.05-.27-.1-.43-.16-.23-.08-.48-.19-.79-.33-.61-.27-1.36-.6-2.26-.83-1.06-.27-2.33-.43-3.68-.59-.36-.04-.74-.09-1.12-.14-.41-.04-.76-.06-1.08-.06-.74,0-1.38.11-1.96.33-.46.17-.92.45-1.32.81l.05-.66.18-2.53c.05-.77.18-1.93.32-3.18h0ZM667.18,616.34c0-.06.01-.22.03-.44v-.03c.11-1.65.13-2.25.07-2.48-.05-.21-.16-.43-.3-.6-.13-.16-.26-.27-.38-.36-.41-.3-.76-.52-1.05-.7-.32-.2-.58-.35-.78-.44-.07-.6-.15-1.07-.25-1.51l-.03-.15c-.08-.33-.17-.71-.42-1.1-.26-.39-.68-.67-1.27-.82-1.19-.3-2.42-.46-3.76-.49-.1,0-.21,0-.31,0-1.93,0-3.23.28-3.73.39h-.07c-1.61.36-2.84.93-3.42,1.25-.38.21-.71.42-.95.6-.7-.42-2.79-1.04-4.76-1.42l-.08-.02c-.23-.04-.65-.12-1.22-.22h-.07c-.63-.11-1.49-.25-2.52-.29-.1,0-.21,0-.32,0-.86,0-2.16.08-3.43.79-.03.02-.06.04-.1.06h-.02c-.11.08-.24.16-.35.25l-.06.05c-.13.1-.27.2-.41.36-.21.21-.37.54-.4.82-.03.2-.03.38-.03.53v.45c-.3.03-.68.16-1.05.36-.34.19-.81.46-1.18,1.04v.02s-.2.38-.2.38l-.04.09c-.03.07-.06.16-.08.24-.02.12-.03.25-.01.39,0,.07.01.13.02.18v.05s.01.07.02.14l.02.41c.03.42.03,2.19.03,4.65v.04c0,.85,0,1.78,0,2.78,0,.82.03,1.66.07,2.55.05,1.26.1,2.56.07,3.92l-.13,5.37-.03,1.46c0,.05,0,.15.01.24.03.21.13.4.27.52.15.14.36.21.6.21.14,0,.26-.02.33-.04l.38-.1.75-.21,1.46-.44,2.78-.85c1.86-.56,3.49-.94,4.85-1.15.87-.13,1.72-.2,2.54-.2.3,0,.59,0,.87.03.42.02.74.06.96.08.16.02.26.03.33.03.05,0,.1,0,.14-.02.13.07.32.1.56.12.1,0,.26.03.44.06.26.04.55.09.83.11.39.03.84.11,1.38.21.71.13,1.52.27,2.43.34.41.04.85.07,1.27.09,1.25.08,2.67.17,4.09.51.82.19,1.63.55,2.48.93l.33.15.38.16.2.08.11.04c.07.03.15.05.21.05.06.01.13.02.2.02.34,0,.64-.18.78-.46.07-.13.11-.29.12-.48l.09-1.83c.07-1.41.21-2.83.35-4.21.14-1.36.27-2.65.33-3.92.19-4.02.11-6.41.06-7.69-.01-.44-.03-.76-.02-.95h0Z"
            />
            <g>
              <polygon
                class="four_st16"
                points="629.13 649.75 629.13 660.02 634.71 660.02 634.71 658.98 630.31 658.98 630.31 649.75 629.13 649.75 629.13 649.75"
              />
              <path
                class="four_st16"
                d="M636.55,660.02h1.14v-7.97h-1.14v7.97h0ZM636.22,649.73c0,.47.37.82.82.82.48,0,.85-.35.85-.82s-.37-.83-.85-.83c-.45,0-.82.35-.82.83h0Z"
              />
              <path
                class="four_st16"
                d="M640.4,659.74c.48.25,1.24.42,2.24.42,2.64,0,3.91-1.79,3.91-4.38,0-2.72-1.36-3.81-3.03-3.81-1,0-1.68.41-1.93.62h-.06v-3.69h-1.13v10.84h0ZM642.81,659.17c-.5,0-.97-.09-1.27-.22v-5.18c.37-.5,1.04-.79,1.67-.79,1.11,0,2.2.66,2.2,2.97,0,2.15-1.04,3.22-2.59,3.22h0Z"
              />
              <path
                class="four_st16"
                d="M652.54,651.99c-.18-.04-.44-.07-.81-.07-.92,0-1.66.44-2.01,1.01h-.06l-.25-.88h-.86v7.97h1.13v-5.93c.38-.72,1.19-1.03,1.96-1.03.29,0,.6.03.89.12v-1.19h0Z"
              />
              <path
                class="four_st16"
                d="M657.67,658.16c-.37.54-1.08,1.08-1.99,1.08s-1.44-.57-1.44-1.27c0-1.2,1.51-1.67,3.43-1.6v1.79h0ZM656.01,651.93c-1.65,0-2.4.92-2.68,1.3l.84.66c.23-.38.75-.97,1.82-.97s1.68.38,1.68,1.68v.86c-2.83-.04-4.56.82-4.56,2.58,0,1.08.82,2.12,2.3,2.12,1.35,0,1.99-.63,2.37-1.07h.06c.19.54.66.97,1.45.97.15,0,.31-.03.41-.09v-.84h-.21c-.56,0-.78-.48-.78-1.2v-3.6c0-1.67-1.01-2.42-2.71-2.42h0Z"
              />
              <path
                class="four_st16"
                d="M665.52,651.99c-.18-.04-.44-.07-.81-.07-.92,0-1.66.44-2.01,1.01h-.06l-.25-.88h-.86v7.97h1.13v-5.93c.38-.72,1.19-1.03,1.96-1.03.29,0,.6.03.89.12v-1.19h0Z"
              />
              <path
                class="four_st16"
                d="M665.77,662.93c.19.07.51.15.91.15,1.63,0,2.42-1.01,2.91-2.51l2.81-8.52h-1.19l-1.23,3.91c-.51,1.64-.69,2.31-.82,2.9h-.06c-.19-.69-.43-1.46-.89-2.9l-1.29-3.91h-1.23l2.89,8.25c-.35,1.23-.89,1.76-1.89,1.76-.22,0-.54-.06-.75-.13l-.18,1.01h0Z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default SlideFour;
